export interface NewsFeedLink {
  lookup: string;
  label: string;
}

export interface NewsFeedGroup {
  title: string;
  links: NewsFeedLink[];
}

export const newsFeedGroups: NewsFeedGroup[] = [
  {
    "title": "World News",
    "links": [
      {
        "lookup": "world_top",
        "label": "Top Stories"
      },
      {
        "lookup": "world_africa",
        "label": "Africa"
      },
      {
        "lookup": "world_canada",
        "label": "Canada"
      },
      {
        "lookup": "world_americas",
        "label": "Americas"
      },
      {
        "lookup": "world_asia",
        "label": "Asia"
      },
      {
        "lookup": "world_europe",
        "label": "Europe"
      },
      {
        "lookup": "world_us",
        "label": "US"
      },
      {
        "lookup": "world_middle_east",
        "label": "Middle East"
      },
      {
        "lookup": "world_north_america",
        "label": "North America"
      },
      {
        "lookup": "world_south_america",
        "label": "South America"
      }
    ]
  },
  {
    "title": "Business News",
    "links": [
      {
        "lookup": "business_top",
        "label": "Top Stories"
      },
      {
        "lookup": "business_africa",
        "label": "Africa"
      },
      {
        "lookup": "business_asia",
        "label": "Asia"
      },
      {
        "lookup": "business_europe",
        "label": "Europe"
      },
      {
        "lookup": "business_us",
        "label": "US"
      },
      {
        "lookup": "business_middle_east",
        "label": "Middle East"
      }
    ]
  },
  {
    "title": "Political News",
    "links": [
      {
        "lookup": "political_top",
        "label": "Top Stories"
      },
      {
        "lookup": "political_asia",
        "label": "Asia"
      },
      {
        "lookup": "political_canada",
        "label": "Canada"
      },
      {
        "lookup": "political_europe",
        "label": "Europe"
      },
      {
        "lookup": "political_us",
        "label": "US"
      },
      {
        "lookup": "political_middle_east",
        "label": "Middle East"
      }
    ]
  },
  {
    "title": "Africa",
    "links": [
      {
        "lookup": "africa",
        "label": "Top Stories - Africa"
      },
      {
        "lookup": "egypt",
        "label": "Egypt"
      },
      {
        "lookup": "ghana",
        "label": "Ghana"
      },
      {
        "lookup": "kenya",
        "label": "Kenya"
      },
      {
        "lookup": "mauritius",
        "label": "Mauritius"
      },
      {
        "lookup": "nigeria",
        "label": "Nigeria"
      },
      {
        "lookup": "senegal",
        "label": "Senegal"
      },
      {
        "lookup": "tanzania",
        "label": "Tanzania"
      },
      {
        "lookup": "zambia",
        "label": "Zambia"
      },
      {
        "lookup": "zimbabwe",
        "label": "Zimbabwe"
      }
    ]
  },
  {
    "title": "Asia Pacific",
    "links": [
      {
        "lookup": "asia",
        "label": "Top Stories"
      },
      {
        "lookup": "australia",
        "label": "Australia"
      },
      {
        "lookup": "china",
        "label": "China"
      },
      {
        "lookup": "hong_kong",
        "label": "Hong Kong"
      },
      {
        "lookup": "india",
        "label": "India"
      },
      {
        "lookup": "indonesia",
        "label": "Indonesia"
      },
      {
        "lookup": "korea",
        "label": "Korea"
      },
      {
        "lookup": "malaysia",
        "label": "Malaysia"
      },
      {
        "lookup": "new_zealand",
        "label": "New Zealand"
      },
      {
        "lookup": "pakistan",
        "label": "Pakistan"
      },
      {
        "lookup": "philippines",
        "label": "Philippines"
      },
      {
        "lookup": "singapore",
        "label": "Singapore"
      },
      {
        "lookup": "taiwan",
        "label": "Taiwan"
      },
      {
        "lookup": "thailand",
        "label": "Thailand"
      },
      {
        "lookup": "vietnam",
        "label": "Vietnam"
      }
    ]
  },
  {
    "title": "Canada",
    "links": [
      {
        "lookup": "canada",
        "label": "Top Stories"
      },
      {
        "lookup": "alberta",
        "label": "Alberta"
      },
      {
        "lookup": "british_columbia",
        "label": "British Columbia"
      },
      {
        "lookup": "manitoba",
        "label": "Manitoba"
      },
      {
        "lookup": "new_brunswick",
        "label": "New Brunswick"
      },
      {
        "lookup": "newfoundland",
        "label": "Newfoundland"
      },
      {
        "lookup": "northwest_territories",
        "label": "Northwest Territories"
      },
      {
        "lookup": "nova_scotia",
        "label": "Nova Scotia"
      },
      {
        "lookup": "ontario",
        "label": "Ontario"
      },
      {
        "lookup": "prince_edwards_island",
        "label": "Prince Edwards Island"
      },
      {
        "lookup": "quebec",
        "label": "Quebec"
      },
      {
        "lookup": "saskatchewan",
        "label": "Saskatchewan"
      }
    ]
  },
  {
    "title": "Caribbean",
    "links": [
      {
        "lookup": "anguilla",
        "label": "Anguilla"
      },
      {
        "lookup": "aruba",
        "label": "Aruba"
      },
      {
        "lookup": "bahamas",
        "label": "Bahamas"
      },
      {
        "lookup": "barbados",
        "label": "Barbados"
      },
      {
        "lookup": "bermuda",
        "label": "Bermuda"
      },
      {
        "lookup": "british_virgin_islands",
        "label": "British Virgin Islands"
      },
      {
        "lookup": "cayman_islands",
        "label": "Cayman Islands"
      },
      {
        "lookup": "dominican_republic",
        "label": "Dominican Republic"
      },
      {
        "lookup": "grenada",
        "label": "Grenada"
      },
      {
        "lookup": "jamaica",
        "label": "Jamaica"
      },
      {
        "lookup": "netherlands_antilles",
        "label": "Netherlands Antilles"
      },
      {
        "lookup": "puerto_rico",
        "label": "Puerto Rico"
      },
      {
        "lookup": "saint_kitts_and_nevis",
        "label": "Saint Kitts and Nevis"
      },
      {
        "lookup": "trinidad_and_tabago",
        "label": "Trinidad and Tabago"
      },
      {
        "lookup": "turks_and_caicos",
        "label": "Turks and Caicos"
      },
      {
        "lookup": "us_virgin_islands",
        "label": "US Virgin Islands"
      }
    ]
  },
  {
    "title": "Europe",
    "links": [
      {
        "lookup": "europe",
        "label": "Top Stories"
      },
      {
        "lookup": "austria",
        "label": "Austria"
      },
      {
        "lookup": "belgium",
        "label": "Belgium"
      },
      {
        "lookup": "bulgaria",
        "label": "Bulgaria"
      },
      {
        "lookup": "cyprus",
        "label": "Cyprus"
      },
      {
        "lookup": "czech_republic",
        "label": "Czech Republic"
      },
      {
        "lookup": "denmark",
        "label": "Denmark"
      },
      {
        "lookup": "england",
        "label": "England"
      },
      {
        "lookup": "estonia",
        "label": "Estonia"
      },
      {
        "lookup": "finland",
        "label": "Finland"
      },
      {
        "lookup": "france",
        "label": "France"
      },
      {
        "lookup": "germany",
        "label": "Germany"
      },
      {
        "lookup": "gibraltar",
        "label": "Gibraltar"
      },
      {
        "lookup": "greece",
        "label": "Greece"
      },
      {
        "lookup": "hungary",
        "label": "Hungary"
      },
      {
        "lookup": "ireland",
        "label": "Ireland"
      },
      {
        "lookup": "isle_of_man",
        "label": "Isle of Man"
      },
      {
        "lookup": "latvia",
        "label": "Latvia"
      },
      {
        "lookup": "lithuania",
        "label": "Lithuania"
      },
      {
        "lookup": "luxembourg",
        "label": "Luxembourg"
      },
      {
        "lookup": "malta",
        "label": "Malta"
      },
      {
        "lookup": "netherlands",
        "label": "Netherlands"
      },
      {
        "lookup": "norway",
        "label": "Norway"
      },
      {
        "lookup": "poland",
        "label": "Poland"
      },
      {
        "lookup": "portugal",
        "label": "Portugal"
      },
      {
        "lookup": "romania",
        "label": "Romania"
      },
      {
        "lookup": "russia",
        "label": "Russia"
      },
      {
        "lookup": "scotland",
        "label": "Scotland"
      },
      {
        "lookup": "serbia",
        "label": "Serbia"
      },
      {
        "lookup": "slovakia",
        "label": "Slovakia"
      },
      {
        "lookup": "spain",
        "label": "Spain"
      },
      {
        "lookup": "sweden",
        "label": "Sweden"
      },
      {
        "lookup": "turkey",
        "label": "Turkey"
      },
      {
        "lookup": "ukraine",
        "label": "Ukraine"
      }
    ]
  },
  {
    "title": "Latin America",
    "links": [
      {
        "lookup": "south_america",
        "label": "Top Stories"
      },
      {
        "lookup": "argentina",
        "label": "Argentina"
      },
      {
        "lookup": "bolivia",
        "label": "Bolivia"
      },
      {
        "lookup": "brazil",
        "label": "Brazil"
      },
      {
        "lookup": "chile",
        "label": "Chile"
      },
      {
        "lookup": "colombia",
        "label": "Colombia"
      },
      {
        "lookup": "costa_rica",
        "label": "Costa Rica"
      },
      {
        "lookup": "ecuador",
        "label": "Ecuador"
      },
      {
        "lookup": "el_salvador",
        "label": "El Salvador"
      },
      {
        "lookup": "guatemala",
        "label": "Guatemala"
      },
      {
        "lookup": "honduras",
        "label": "Honduras"
      },
      {
        "lookup": "mexico",
        "label": "Mexico"
      },
      {
        "lookup": "nicaragua",
        "label": "Nicaragua"
      },
      {
        "lookup": "panama",
        "label": "Panama"
      },
      {
        "lookup": "paraguay",
        "label": "Paraguay"
      },
      {
        "lookup": "peru",
        "label": "Peru"
      },
      {
        "lookup": "uruguay",
        "label": "Uruguay"
      },
      {
        "lookup": "venezuela",
        "label": "Venezuela"
      }
    ]
  },
  {
    "title": "Middle East",
    "links": [
      {
        "lookup": "middle_east",
        "label": "Top Stories - Middle East"
      },
      {
        "lookup": "kuwait",
        "label": "Kuwait"
      },
      {
        "lookup": "tunisia",
        "label": "Tunisia"
      },
      {
        "lookup": "united_arab_emirates",
        "label": "United Arab Emirates"
      }
    ]
  },
  {
    "title": "USA",
    "links": [
      {
        "lookup": "united_states",
        "label": "Top Stories"
      },
      {
        "lookup": "alabama",
        "label": "Alabama"
      },
      {
        "lookup": "alaska",
        "label": "Alaska"
      },
      {
        "lookup": "arizona",
        "label": "Arizona"
      },
      {
        "lookup": "arkansas",
        "label": "Arkansas"
      },
      {
        "lookup": "california",
        "label": "California"
      },
      {
        "lookup": "colorado",
        "label": "Colorado"
      },
      {
        "lookup": "connecticut",
        "label": "Connecticut"
      },
      {
        "lookup": "deleware",
        "label": "Deleware"
      },
      {
        "lookup": "district_of_columbia",
        "label": "District of Columbia"
      },
      {
        "lookup": "florida",
        "label": "Florida"
      },
      {
        "lookup": "georgia",
        "label": "Georgia"
      },
      {
        "lookup": "hawaii",
        "label": "Hawaii"
      },
      {
        "lookup": "idaho",
        "label": "Idaho"
      },
      {
        "lookup": "illinois",
        "label": "Illinois"
      },
      {
        "lookup": "indiana",
        "label": "Indiana"
      },
      {
        "lookup": "iowa",
        "label": "Iowa"
      },
      {
        "lookup": "louisiana",
        "label": "Louisiana"
      },
      {
        "lookup": "kansas",
        "label": "Kansas"
      },
      {
        "lookup": "kentucky",
        "label": "Kentucky"
      },
      {
        "lookup": "maine",
        "label": "Maine"
      },
      {
        "lookup": "maryland",
        "label": "Maryland"
      },
      {
        "lookup": "massachusetts",
        "label": "Massachusetts"
      },
      {
        "lookup": "michigan",
        "label": "Michigan"
      },
      {
        "lookup": "minnesota",
        "label": "Minnesota"
      },
      {
        "lookup": "mississippi",
        "label": "Mississippi"
      },
      {
        "lookup": "missouri",
        "label": "Missouri"
      },
      {
        "lookup": "montana",
        "label": "Montana"
      },
      {
        "lookup": "nebraska",
        "label": "Nebraska"
      },
      {
        "lookup": "new_hampshire",
        "label": "New Hampshire"
      },
      {
        "lookup": "new_jersey",
        "label": "New Jersey"
      },
      {
        "lookup": "new_mexico",
        "label": "New Mexico"
      },
      {
        "lookup": "new_york",
        "label": "New York"
      },
      {
        "lookup": "north_carolina",
        "label": "North Carolina"
      },
      {
        "lookup": "north_dakota",
        "label": "North Dakota"
      },
      {
        "lookup": "ohio",
        "label": "Ohio"
      },
      {
        "lookup": "oklahoma",
        "label": "Oklahoma"
      },
      {
        "lookup": "oregon",
        "label": "Oregon"
      },
      {
        "lookup": "pennsylvania",
        "label": "Pennsylvania"
      },
      {
        "lookup": "rhode_island",
        "label": "Rhode Island"
      },
      {
        "lookup": "south_carolina",
        "label": "South Carolina"
      },
      {
        "lookup": "south_dakota",
        "label": "South Dakota"
      },
      {
        "lookup": "tennessee",
        "label": "Tennessee"
      },
      {
        "lookup": "texas",
        "label": "Texas"
      },
      {
        "lookup": "utah",
        "label": "Utah"
      },
      {
        "lookup": "virginia",
        "label": "Virginia"
      },
      {
        "lookup": "vermont",
        "label": "Vermont"
      },
      {
        "lookup": "washington",
        "label": "Washington"
      },
      {
        "lookup": "west_virginia",
        "label": "West Virginia"
      },
      {
        "lookup": "wisconsin",
        "label": "Wisconsin"
      },
      {
        "lookup": "wyoming",
        "label": "Wyoming"
      }
    ]
  },
  {
    "title": "Industry News",
    "links": [
      {
        "lookup": "agriculture",
        "label": "Agriculture"
      },
      {
        "lookup": "construction_engineering_infrastructure",
        "label": "Construction Engineering & Infrastructure"
      },
      {
        "lookup": "corporate_business_antitrust",
        "label": "Corporate Business Antitrust"
      },
      {
        "lookup": "dispute_resolution",
        "label": "Dispute Resolution"
      },
      {
        "lookup": "e_commerce",
        "label": "E-Commerce"
      },
      {
        "lookup": "employement_labor_industrial_relations",
        "label": "Employement Labor & Industrial Relations"
      },
      {
        "lookup": "entertainment_media_leisure",
        "label": "Entertainment Media & Leisure"
      },
      {
        "lookup": "environment",
        "label": "Environment"
      },
      {
        "lookup": "financial_services",
        "label": "Financial Services"
      },
      {
        "lookup": "health_medicine",
        "label": "Health & Medicine"
      },
      {
        "lookup": "insurance_reinsurance",
        "label": "Insurance & Reinsurance"
      },
      {
        "lookup": "natural_resources",
        "label": "Natural Resources"
      },
      {
        "lookup": "real_estate",
        "label": "Real Estate"
      },
      {
        "lookup": "science_technology",
        "label": "Science & Technology"
      },
      {
        "lookup": "society_education",
        "label": "Society & Education"
      },
      {
        "lookup": "trade_investment",
        "label": "Trade & Investment"
      },
      {
        "lookup": "transportation",
        "label": "Transportation"
      }
    ]
  },
  {
    "title": "Other News",
    "links": [
      {
        "lookup": "accounting",
        "label": "Accounting"
      },
      {
        "lookup": "economy",
        "label": "Economy"
      },
      {
        "lookup": "information_technology",
        "label": "Information Technology"
      },
      {
        "lookup": "internet",
        "label": "Internet"
      },
      {
        "lookup": "investing",
        "label": "Investing"
      },
      {
        "lookup": "management",
        "label": "Management"
      },
      {
        "lookup": "markets",
        "label": "Markets"
      },
      {
        "lookup": "media",
        "label": "Media"
      },
      {
        "lookup": "nasdaq",
        "label": "NASDAQ"
      },
      {
        "lookup": "nyse",
        "label": "NYSE"
      },
      {
        "lookup": "oil",
        "label": "Oil"
      },
      {
        "lookup": "sports",
        "label": "Sports"
      },
      {
        "lookup": "this_day_in_history",
        "label": "This Day in History"
      },
      {
        "lookup": "travel",
        "label": "Travel"
      }
    ]
  }
];
